/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

$('[data-tab-group]').on('click', '[data-tab-toggle]', function (e) {
    e.preventDefault();

    var tabContent = $('[data-tab="' + $(this).data('tab-toggle') + '"]'),
            tabGroup = $(this).closest('[data-tab-group]');

    tabGroup.find('[data-tab-toggle]').removeClass('active');
    tabGroup.find('[data-tab]').removeClass('active');
    tabContent.addClass('active');
    $('[data-tab-toggle="' + $(this).data('tab-toggle') + '"]').addClass('active');
});
